import { ControlOutlined } from "@ant-design/icons";
import { configurationAuthScope, CrudOp } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { ConfigurationManagerView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand }) => {
  const authHelper = authHelperCreator(configurationAuthScope);
  return brand != null && authHelper.evaluate(CrudOp.READ, brand);
};

export const configurationManagerViewKey = "configuration_modular_configurationManager/:projectId/:subprojectId/:brand/:modelYear/:mbvKeys/:tmmId";
export const configurationManagerViewModule: ViewModule = {
  viewKey: configurationManagerViewKey,
  viewEl: <ConfigurationManagerView/>,
  displayNameI18nKey: "configuration:configurationManager.viewName",
  menuIconEl: <ControlOutlined/>,
  isAuthorized,
  translations,
};
